module.exports = __webpack_public_path__ + "img/icon-mail.b3fd68ab.svg";